module.exports = "search-magnifier"